import { __exports as useSyncExternalStore_production_min } from '../../../../../../_virtual/use-sync-external-store.production.min.js';
import React from 'react';

/**
 * @license React
 * use-sync-external-store.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var hasRequiredUseSyncExternalStore_production_min;

function requireUseSyncExternalStore_production_min () {
	if (hasRequiredUseSyncExternalStore_production_min) return useSyncExternalStore_production_min;
	hasRequiredUseSyncExternalStore_production_min = 1;
var a=React.useSyncExternalStore;useSyncExternalStore_production_min.useSyncExternalStore=a;
	return useSyncExternalStore_production_min;
}

export { requireUseSyncExternalStore_production_min as __require };
